import SWelcome from "@/components/Welcome/59sWelcome";
import { NextPage } from "next";
import { NextSeo } from "next-seo";



const SWelcomePage: NextPage = () => {

  return (
    <>
      <NextSeo
        title='59s Welcome'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/59s-welcome"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/59s-logo-(150x100).jpg",
            width: 150,
            height: 100,
            alt: '59s logo image',
          }]
        }}
      />
      <SWelcome />
    </>
  )
}

export default SWelcomePage
